import SendingInvoiceToEd from './SendingInvoiceToEd.component';

export default SendingInvoiceToEd;